import React from "react";
import SubscriptionSection from './SubscriptionSection';
;
import { logged, onLoaderReady } from "Common/utility/socialLogin"

function getText(el, selector){
  if(!el){
      return '';
  }

  let child = el.querySelector(selector);
  return child ? child.textContent : '';
}

function getAll(el, selector){
  if(!el){
      return [];
  }
  return Array.from(el.querySelectorAll(selector));
}

export default class Subscription extends React.Component {
  constructor(props){
    super(props);
    
    this.state = {
      needLogin: false
    }
  }

  componentDidMount() {
    onLoaderReady((loader) => {
      const needLogin = !logged();
      this.setState({needLogin: needLogin});
    });
  }

  render() {
    let config = this.props.config;
    if(!config){
      return 'Loading';
    }

    let props = {
      title: getText(config, 'title'),
      subTitle: getText(config, 'subTitle'),
      regAction: this.state.needLogin ? getText(config, 'regAction') : null,
      regActionUrl: getText(config, 'regActionUrl'),
      regActionTarget: getText(config, 'regActionTarget') || '_self',
      benefits: {
        title: getText(config, 'benefits title'),
        list: getAll(config, 'benefits list item').map(item => item.textContent)
      }
    }

    return (
      <SubscriptionSection {...props} />
    );
  }
}
